<template>
  <div>
    <b-table class="agv-table" bordered hover :items="items" :fields="fields">
      <template #cell(password)="row">
        <appUserPasswordBlock
          :password="row.item.password"
          :show-password="row.item.showPassword"
          @toggleShowPassword="row.item.showPassword = !row.item.showPassword"
        />
      </template>
      <template v-slot:cell(actions)="row">
        <b-row class="actions text-center" style="min-weight: 150px;">
          <b-col>
            <!-- <b-button
              size="sm"
              :title="$t('general.edit')"
              class="tablebutton btn-edit"
              @click="EDIT(row.item)"
            >
              <font-awesome-icon icon="pen" size="1x" />
            </b-button> -->
            <b-button class="tablebutton btn-red">
              <b-button
                size="sm"
                :title="$t('general.delete')"
                class="tablebutton btn-red"
                @click="DELETE_GUEST(row.item)"
              >
                <font-awesome-icon icon="trash-alt" size="1x" />
              </b-button>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-table>
  </div>
</template>

<script>
import MeetingGuestMW from "@/middlewares/MeetingGuest";

import appUserPasswordBlock from "@/components/snippets/UserPasswordBlock";

export default {
  components: {
    appUserPasswordBlock,
  },
  props: {
    meetingId: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "fullname",
          label: "Nom complet",
          sortable: true,
          tdClass: "text-left",
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          tdClass: "text-left",
        },
        {
          key: "username",
          label: "Nom d'utilisateur",
          sortable: false,
          tdClass: "text-left",
        },
        {
          key: "password",
          label: "Mot de passe",
          sortable: false,
          tdClass: "text-left",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          tdClass: "text-center",
        },
      ],
    };
  },
  methods: {
    DELETE_GUEST(item) {
      MeetingGuestMW.DELETE(item);
    },
  },
};
</script>
